import styled from 'styled-components';

export const NameAndIconContainer = styled.div`
  text-decoration: none;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: flex-end;
  align-items: flex-end;
  border-radius: 58px;
`;
